// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__2e6Ce","containerItemsCenter":"Skeleton_containerItemsCenter__3f2Xw"};